import api from '@/lib/axios';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export interface OrgSchoolOption {
  id: string;
  name: string;
}

export interface PermissionModule {
  key: string;
  label: string;
  group: string;
  actions: string[];
}

export interface PermissionCatalog {
  modules: PermissionModule[];
  permissions: string[];
}

export interface RoleView {
  id: string | null;
  key: string;
  name: string;
  description: string | null;
  isSystem: boolean;
  permissions: string[];
  userCount: number;
}

export interface SaveRoleData {
  name: string;
  description?: string;
  permissions: string[];
}

export const OrgRolesApi = {
  schools: async (): Promise<OrgSchoolOption[]> => unwrap(await api.get('/org/roles/schools')),

  catalog: async (): Promise<PermissionCatalog> => unwrap(await api.get('/org/roles/catalog')),

  list: async (schoolId: string): Promise<RoleView[]> => unwrap(await api.get('/org/roles', { params: { schoolId } })),

  create: async (schoolId: string, data: SaveRoleData): Promise<RoleView> => unwrap(await api.post('/org/roles', { ...data, schoolId })),

  update: async (id: string, schoolId: string, data: Partial<SaveRoleData>): Promise<RoleView> =>
    unwrap(await api.patch(`/org/roles/${id}`, { ...data, schoolId })),

  remove: async (id: string, schoolId: string): Promise<{ deleted: true; id: string }> =>
    unwrap(await api.delete(`/org/roles/${id}`, { params: { schoolId } })),
};
